import { encodePaginatableQuery, encodeSortableQuery, PaginatableQuery, Query, SortableQuery } from '@/services/api';
import * as q from '@/services/api/request/query';

export interface EntityItemQuery extends PaginatableQuery, SortableQuery {
  search: string;
  entityType: number[];
  entityFolder: number[];
  entityFolderRecursive?: number[];
  user: number[];
}

export const encodeEntityItemQuery = (query: EntityItemQuery): Query => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
  entityType: q.numbers(query.entityType || []),
  entityFolder: q.numbers(query.entityFolder || []),
  entityFolderRecursive: query.entityFolderRecursive ? q.numbers(query.entityFolderRecursive || []) : '',
  user: q.numbers(query.user),
  ...encodeSortableQuery(query),
});

export const defaultEntityItemQuery: () => EntityItemQuery = () => ({
  search: '',
  entityType: [],
  entityFolder: [],
  entityFolderRecursive: [],
  user: [],
  sort: '',
  dir: '',
  page: 1,
  perPage: 10000,
});
